import React from 'react';
import { Typography } from '@mui/material';
import { useI18n } from '../../../lib/hook/useI18n';
import PrivacyPolicyLink from '../../ConsentPromp/PrivacyPolicyLink';

interface Props {
  actionText: string;
}

const UnifiedConsentText: React.FC<Props> = ({ actionText }): JSX.Element => {
  const { i18nClasses, tc } = useI18n();

  return (
    <Typography
      className={i18nClasses.root}
      color="textSecondary"
      variant="body2"
    >
      {tc(
        'room.welcome.modal.consent',
        { actionText },
        {
          privacyPolicyLink: (
            <PrivacyPolicyLink color="primary" variant="body2" />
          ),
        },
        true
      )}
    </Typography>
  );
};

export default UnifiedConsentText;
